import React, {useEffect, useMemo, useState} from 'react';
import moment from 'moment';
import {find, isNil} from 'lodash';
import {useDispatch} from 'react-redux';
import API from '../../../../../app/api';
import {setSnackbar} from '../../../../../store/reducers/globals';
import TruncatedText from '../../../../../components/ui/text/truncatedText';
import AgyleDialog from '../../../../../components/modal/agyleDialog';
import {getConsultantName} from '../../../../admit/admitUtils';
import { SLOT_STATUSES } from "../../../../appointments/utils/constants/appointmentSessionConstants";
import AgyleLoadingSpinner from '../../../../../components/other/agyleLoadingSpinner';
import {Box, Divider, Stack, Grid} from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';

export default function AppointmentDetails({ appointment, onClose }) {
    const dispatch = useDispatch();

    const [sessionDetails, setSessionDetails] = useState(null);
    const [sessionDetailsLoading, setSessionDetailsLoading] = useState(false);

    const appStatus = useMemo(() => find(SLOT_STATUSES, { value: appointment?.status }), [appointment?.status]);

    useEffect(() => {
        if (appointment?.assignedSession) {
            const abortController = new AbortController();

            const fetchSession = async () => {
                setSessionDetailsLoading(true);
                try {
                    const session = await API.getAppointmentSession(appointment?.assignedSession, abortController.signal);

                    if (session) setSessionDetails(session);
                } catch (err) {
                    dispatch(setSnackbar({ type: 'error', message: "Error getting assigned slot's session details." }))
                } finally {
                    setSessionDetailsLoading(false);
                }
            }

            fetchSession();

            return () => abortController.abort();
        }
    }, [appointment?.assignedSession])

    const renderInfoRow = (label, value) => {
        return <Stack direction='row' gap={1} alignItems='center'>
            <Box width={120}>
                <TruncatedText text={`${label}:`}/>
            </Box>

            <TruncatedText text={value} />
        </Stack>
    }

    return (
        <AgyleDialog open={appointment?.__id} onClose={onClose} title="Appointment" fullWidth darkContentBackground disableEscapeKeyDown disableSave closeButtonOnHeader>
            <Grid container item xs={12}>
                <Grid item xs={12} >
                    <Stack gap={1}>
                        <Divider>Appointment Details</Divider>
                        {renderInfoRow("Start Date", moment(appointment.startDate).format("DD-MM-YYYY HH:mm A"))}
                        {renderInfoRow("End Date", moment(appointment.endDate).format("DD-MM-YYYY HH:mm A"))}
                        {renderInfoRow("Reason", appointment.description)}
                        {appStatus?.name && renderInfoRow("Status", appStatus?.name)}


                        {/* Session Specific data */}
                        {sessionDetailsLoading && <AgyleLoadingSpinner label='Loading session details...' />}

                        {!isNil(sessionDetails) && <Divider>Session Details</Divider>}

                        {sessionDetails?.hospital?.description && (
                            <Stack direction='row' gap={1} alignItems='center'>
                                <ApartmentIcon/>

                                <TruncatedText text={sessionDetails?.hospital?.description} />
                            </Stack>
                        )}
                        {sessionDetails?.sessionName && renderInfoRow("Session Name", sessionDetails?.sessionName)}
                        {sessionDetails?.clinic?.description && renderInfoRow("Clinic", sessionDetails?.clinic?.description)}
                        {sessionDetails?.consultant && renderInfoRow("Consultant", getConsultantName(sessionDetails?.consultant))}
                        {sessionDetails?.specialty && renderInfoRow("Specialty", sessionDetails?.specialty?.__description)}
                    </Stack>
                </Grid>
            </Grid>
        </AgyleDialog>
    )
}